import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Container,
  Typography,
  Chip,
  Breadcrumbs,
  Link
} from '@material-ui/core';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CustomModal from 'src/components/CustomModal';
import Page from 'src/components/Page';
import CustomDataTable from 'src/components/Table/CustomDataTable';
import { useStyles } from 'src/theme';
import { getClientsStaffAction } from 'src/store/actions/ClientManagerActions';
import useProfile from 'src/hooks/useProfile';
import ConfirmationDialog from './ConfirmationDialog';

const ClientStaffs = () => {
  const classes = useStyles();
  const { state } = useLocation();
  const dispatch = useDispatch();
  const { isAdmin } = useProfile();
  const clientsStaff = useSelector((state) => state.Clients.clientsStaff);
  const [modalControl, setModalControl] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [loading, setLoading] = React.useState(false);

  const handleModalOpen = (e, data) => {
    const currModalID = e.currentTarget.id;
    if (currModalID) setModalControl(currModalID);
    if (data) setModalData(data);
  };

  const closeModal = () => {
    setModalControl(false);
    setModalData(null);
  };

  useEffect(() => {
    if (state) {
      setLoading(true);
      const filter = { issuerID: state.issuerID };
      Promise.resolve(dispatch(getClientsStaffAction(filter, isAdmin))).then(
        () => {
          setLoading(false);
        }
      );
    }
  }, [state, isAdmin]);

  const tableConfig = [
    {
      title: 'S/N',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'Fullname',
      value: 'fullname',
      align: 'center'
    },
    {
      title: 'Username',
      value: 'username',
      align: 'center'
    },
    {
      title: 'Email',
      value: 'email',
      align: 'center'
    },
    {
      title: 'Phone',
      value: 'phone',
      align: 'center'
    },
    {
      title: 'Last Seen',
      value: 'lastseen',
      align: 'center',
      render: (row) => moment(row.lastseen * 1000).format('DD/MM/YYYY hh:mm a')
    },
    {
      title: 'Valid',
      value: 'valid',
      align: 'center',
      render: (row) =>
        row.valid == 0 ? (
          <Chip
            variant="outlined"
            color="primary"
            size="small"
            label="Deactivated"
          />
        ) : (
          <Chip
            style={{ background: 'green', color: 'white' }}
            size="small"
            label="Active"
          />
        )
    },

    {
      title: 'Status',
      value: 'accessStatus',
      align: 'center',
      render: (row, i) =>
        row.accessStatus == 0 ? (
          <Chip
            variant="outlined"
            color="primary"
            size="small"
            label="Deactivated"
          />
        ) : (
          <Chip
            style={{ background: 'green', color: 'white' }}
            size="small"
            label="Active"
          />
        )
    },
    {
      title: 'Actions',
      value: '',
      align: 'center',
      render: (row, i) => (
        <Box>
          <Button
            id="reset-password"
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            onClick={(e) => handleModalOpen(e, row)}
          >
            Reset Password
          </Button>
          &nbsp;
          <Button
            id="activate"
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            size="small"
            onClick={(e) => handleModalOpen(e, row)}
          >
            {row?.accessStatus == 1 ? 'Disable Account' : 'Enable Account'}
          </Button>
          &nbsp;
          <Button
            id="logout"
            className={classes.actionBtn}
            variant="outlined"
            color="primary"
            size="small"
            onClick={(e) => handleModalOpen(e, row)}
          >
            Logout
          </Button>
        </Box>
      )
    }
  ];

  return (
    <Page className={classes.root} title={`Client ${state?.fullname}`}>
      <Container>
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/client-manager">
            Client Manager
          </Link>
          <Typography color="textPrimary" variant="h4">
            {' '}
            {state?.fullname}
          </Typography>
        </Breadcrumbs>
        <Box my={5}>
          <CustomDataTable
            tableConfig={tableConfig}
            tableData={clientsStaff}
            className={classes}
            filterField="fullname"
            loading={loading}
          />
        </Box>
      </Container>

      <CustomModal
        open={modalControl === 'reset-password'}
        handleClose={closeModal}
        title="Reset Password"
        modalData={modalData}
      >
        <ConfirmationDialog
          handleClose={closeModal}
          message="Are you sure you want to reset this staff password?"
          rowData={modalData}
          title="reset-password"
          isAdmin={isAdmin}
        />
      </CustomModal>
      <CustomModal
        open={modalControl === 'logout'}
        handleClose={closeModal}
        title="Logout Account"
        modalData={modalData}
      >
        <ConfirmationDialog
          handleClose={closeModal}
          message="Are you sure you want to logout this staff account?"
          rowData={modalData}
          title="logout"
          isAdmin={isAdmin}
        />
      </CustomModal>
      <CustomModal
        open={modalControl === 'activate'}
        handleClose={closeModal}
        title="Toggle Account Status"
        modalData={modalData}
      >
        <ConfirmationDialog
          handleClose={closeModal}
          message="Are you sure you want to toggle this staff status?"
          rowData={modalData}
          title="activate"
          isAdmin={isAdmin}
        />
      </CustomModal>
    </Page>
  );
};

export default ClientStaffs;
